var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-view',[_c('div',{staticClass:"px-4"},[_c('div',{staticClass:"is-size-3"},[_vm._v("Error 404. ")]),_vm._v(" Page not found: "),_c('a',{attrs:{"href":_vm.getURL()}},[_vm._v(_vm._s(_vm.getURL()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }